<div class="about-dialog">
  <div class="about-header">About Charity Central</div>
  <div class="about-body">
    <div class="about-row">
      <span class="about-label">This browser is running:</span>
      <span>{{formatBuildTime(clientBuildTime)}}</span>
    </div>
    <div class="about-row">
      <span class="about-label">Latest version on server:</span>
      <span>
        @if (loading) {
          <mat-spinner diameter="16" class="about-spinner"></mat-spinner>
        } @else {
          {{formatBuildTime(serverBuildTime)}}
        }
      </span>
    </div>

    @if (!loading) {
      <div class="about-status" [class.status-ok]="isUpToDate" [class.status-stale]="!isUpToDate">
        @if (isUpToDate) {
          You are running the latest version.
        } @else {
          A newer version is available on the server. Please refresh with Ctrl+F5 (or close and reopen the browser). If this keeps happening after a refresh, send this screen to IT support.
        }
      </div>
    }

    <div class="about-row about-useragent">
      <span class="about-label">Browser:</span>
      <span>{{userAgent}}</span>
    </div>
  </div>
  <div class="about-actions">
    <button mat-raised-button color="primary" class="btn-primary" (click)="close()">Close</button>
  </div>
</div>
